"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _icon = _interopRequireDefault(require("./icon"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function initLogin(accessLevel, JWT) {
  return new Promise(function (resolve, reject) {
    function login() {
      identityWindow = window.open('https://identity.bitclout.com/log-in?accessLevelRequest=' + accessLevel, null, 'toolbar=no, width=800, height=1000, top=0, left=0');
    }

    function handleInit(e) {
      if (!init) {
        init = true;

        var _iterator = _createForOfIteratorHelper(pendingRequests),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;

            _e.source.postMessage(_e, "*");
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        pendingRequests = [];
        pm_id = e.data.id;
        source = e.source;
      }

      respond(e.source, e.data.id, {});
    }

    function handleLogin(payload) {
      user = payload['users'][payload.publicKeyAdded];
      user['publicKey'] = payload.publicKeyAdded;

      if (identityWindow) {
        if (JWT === false) {
          identityWindow.close();
          identityWindow = null;
          resolve(user);
        } else {
          var payload = {
            accessLevel: user.accessLevel,
            accessLevelHmac: user.accessLevelHmac,
            encryptedSeedHex: user.encryptedSeedHex
          };
          source.postMessage({
            id: pm_id,
            service: 'identity',
            method: 'jwt',
            payload: payload
          }, "*");
        }
      }
    }

    function handleJWT(payload) {
      user['jwt'] = payload['jwt'];

      if (identityWindow) {
        identityWindow.close();
        identityWindow = null;
      }

      resolve(user);
    }

    function respond(e, t, n) {
      e.postMessage({
        id: t,
        service: "identity"
      }, "*");
    }

    window.addEventListener('message', function (message) {
      var _message$data = message.data,
          id = _message$data.id,
          method = _message$data.method,
          service = _message$data.service,
          payload = _message$data.payload;

      if (service !== "identity") {
        return;
      }

      ;

      if (method == 'initialize') {
        handleInit(message);
      } else if (method == 'login') {
        handleLogin(payload);
      } else if ('jwt' in payload) {
        handleJWT(payload);
      }
    });
    var init = false;
    var pm_id = '';
    var source = null;
    var user = null;
    var pendingRequests = [];
    var identityWindow = null;
    login();
  });
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    button: {
      backgroundColor: '#FFFFFF',
      textTransform: 'none'
    }
  };
});

var BitcloutLogin = function BitcloutLogin(props) {
  var classes = useStyles();

  var accessLevel = props.accessLevel,
      onSuccess = props.onSuccess,
      onFailure = props.onFailure,
      JWT = props.JWT,
      customization = props.customization,
      customIcon = props.customIcon,
      other = _objectWithoutProperties(props, ["accessLevel", "onSuccess", "onFailure", "JWT", "customization", "customIcon"]);

  var customClassName = '';

  if (customization) {
    customClassName = customization.className;
  }

  var handleLogin = function handleLogin() {
    initLogin(accessLevel, JWT).then(function (e) {
      onSuccess(e);
    }).catch(function (e) {
      onFailure(e);
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    className: classes.button + ' ' + customClassName,
    startIcon: customIcon ? customIcon : /*#__PURE__*/_react.default.createElement(_icon.default, null),
    onClick: handleLogin
  }, "Sign in with Bitclout"));
};

BitcloutLogin.propTypes = {
  accessLevel: _propTypes.default.number.isRequired,
  onSuccess: _propTypes.default.func.isRequired,
  onFailure: _propTypes.default.func.isRequired,
  JWT: _propTypes.default.bool,
  customization: _propTypes.default.object,
  icon: _propTypes.default.element
};
var _default = BitcloutLogin;
exports.default = _default;